module.exports = __webpack_public_path__ + "img/logotipo.1f5fe5ad.1f5fe5ad.png";